import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import type { ToastType } from '../index';
import { Toast } from '@images/imageUrls';

interface PCToastProps {
    message: string;
    type?: ToastType;
    duration?: number;
    onClose?: () => void;
    icon?: string; // 自定义图标URL
    showIcon?: boolean;
}

const PCToast: React.FC<PCToastProps> = ({ message, type = 'success', duration = 2000, onClose, icon, showIcon = true }) => {
    const [visible, setVisible] = useState(false);
    const [shouldRender, setShouldRender] = useState(true);

    useEffect(() => {
        // 延迟显示以触发淡入动画
        const showTimer = setTimeout(() => {
            setVisible(true);
        }, 10);

        // loading类型不自动隐藏
        if (type === 'loading') {
            return () => {
                clearTimeout(showTimer);
            };
        }

        // 隐藏前先触发淡出动画
        const hideTimer = setTimeout(() => {
            setVisible(false);
        }, duration - 300);

        // 完全移除组件
        const removeTimer = setTimeout(() => {
            setShouldRender(false);
            onClose?.();
        }, duration);

        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
            clearTimeout(removeTimer);
        };
    }, [duration, onClose, type]);

    // 根据类型选择图标，优先使用自定义图标
    const getIconSrc = () => {
        // 优先返回自定义图标
        if (icon) {
            return icon;
        }
        
        if (type === 'success') {
            return Toast.success;
        } else if (type === 'loading') {
            return null;
        } else {
            return Toast.warning;
        }
    };

    const iconSrc = getIconSrc();

    return (
        <div className={`${styles.toastContainer} ${visible ? styles.fadeIn : styles.fadeOut}`}>
            <div className={`${styles.toastBox} ${type === 'loading' ? styles.loadingBox : ''}`}>
                {!showIcon ? null : type === 'loading' ? (
                    <div className={styles.spinner}>
                        <div className={styles.spinnerRing}></div>
                        <div className={styles.spinnerRing}></div>
                        <div className={styles.spinnerRing}></div>
                    </div>
                ) : (
                    <img
                        src={iconSrc}
                        alt={type}
                        className={styles.toastIcon}
                    />
                )}
                <span className={styles.toastMessage}>{message}</span>
            </div>
        </div>
    );
};

export default PCToast;
